
export default {
    toolbar: {
        items: [
            'heading',
            '|',
            'alignment',
            'fontSize',
            'fontFamily',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'subscript',
            'superscript',
            'fontColor',
            'fontBackgroundColor',
            'link',
            '|',
            'bulletedList',
            'numberedList',
            'outdent',
            'indent',
            '|',
            'imageUpload',
            'insertImageViaUrl',
            'insertImage',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo'
        ]
    },
    image: {
        toolbar: [
            'imageStyle:alignLeft',
            'imageStyle:full',
            'imageStyle:alignRight',
            '|',
            'imageTextAlternative',
        ],
        styles: [
            'full',
            'alignLeft',
            'alignCenter',
            'alignRight'
        ]
    },
    table: {
        contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells',
            'tableProperties',
            'tableCellProperties'
        ]
    },

    // This value must be kept in sync with the language defined in webpack.config.js.
    language: 'pl'
};
